import React from 'react';
import styles from './BackDrop.module.scss';

const BackDrop = () => {
    return (
        <div className={styles['backdrop']} >
            
        </div>
    )
}

export default BackDrop;
